import React from 'react';

const MessageUserName = (props: { name: string | undefined; isYou: boolean }) => {
    return <span className="fs-5 fw-bolder  text-gray-900 text-hover-primary ms-1">{props.isYou ? props.name : 'Tú'}</span>;
};

export default MessageUserName;
